export var Logger;

export const setupLogger = instance => {
  Logger = instance;
};
